import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BreadcrumbLayout from '@/components/common/CustomLayout/BreadcrumbLayout';
import './index.css';
import Button from '@/components/common/Button';
import { ReactComponent as RiAddLine } from '@/assets/icons/ri-add-line.svg';
import SubscriptionTable from '@/pages/Subscription/List/Table';
import { useAppDispatch } from '@/store';
import { getSubscriptions } from '@/store/subscription/action';
import { getUserVenues } from '@/store/user-info/action';
import useCustomPaging from "@/hooks/useCustomPaging";
import {dynamicAttr} from "@/utils/fallback";
import useGenericSelectFilter from "@/hooks/useGenericSelectFilter";
import useSearchFilter from "@/hooks/useSearchFilter";
import useUserVenueSelectFilter from "@/hooks/useUserVenueSelectFilter";
import useDatePickerFilter from "@/hooks/useDatePickerFilter";
import GenericDatePicker from "@/components/common/GenericDatePicker";
import UserVenueSelect from "@/components/common/UserVenueSelect";
import GenericSelect from "@/components/common/GenericSelect";

const statusOptions = [
	// 'CREATED', 
	'ACTIVE', 
	'INACTIVE', 
	'EXPIRED'
];

const statusSelectOptions = statusOptions.map(s => ({
	value: s,
	label: s.replace('_', ' ')
}))

const Subscription = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [currentPageFilter] = useCustomPaging()
	const [
		searchString,
		currentSearchFilter,
		handleChangeSearchString,
		handleSubmitSearch
	] = useSearchFilter()
	const [
		currentStatusFilter,
		selectedStatus,
		selectStatusOptions,
		handleChangeStatus,
	] = useGenericSelectFilter('status', statusSelectOptions)
	const [
		currentVenueId,
		selectedVenue,
		venueOptions,
		handleChangeVenue,
	] = useUserVenueSelectFilter()
	const [
		createdDateTimestamp,
		currentSelectedDate,
		handleChangeDate
	] = useDatePickerFilter('startDate')

	const handleClickAdd = () => {
		navigate('/dashboard/subscriptions/add');
	};

	const getData = () => {
		const params = {
			size: 10,
			...dynamicAttr('page', currentPageFilter),
			...dynamicAttr('status', currentStatusFilter),
			...dynamicAttr('search', currentSearchFilter),
			...dynamicAttr('venueId', currentVenueId),
			...dynamicAttr('startDate', createdDateTimestamp)
		}
		dispatch(getSubscriptions(params));
	};

	useEffect(() => {
		dispatch(getUserVenues({}));
	}, []);

	useEffect(() => {
		getData();
	}, [
		currentPageFilter,
		currentStatusFilter,
		currentSearchFilter,
		currentVenueId,
		createdDateTimestamp
	]);

	return (
		<BreadcrumbLayout>
			<div className="flex w-full flex-col gap-7">
				<div className="flex w-full justify-between">
					<div className="flex gap-4">
						<div className="text-j2xl font-bold">Subscription</div>
						<div className="separator" />
						<UserVenueSelect
							name="venueId"
							id="venueId"
							placeholder="Select Venue"
							options={venueOptions}
							value={selectedVenue}
							onChange={handleChangeVenue}
						/>
					</div>
					<div className="flex gap-4">
						<input
							value={searchString}
							onChange={handleChangeSearchString}
							onKeyDown={handleSubmitSearch}
							name="searchString"
							type="text"
							className="flex items-center py-[8px] px-4 gap-2 border rounded border-solid border-stroke-subtle text-jsm font-normal"
							placeholder="Search for Subscription"/>
						<div className="separator" />
						<Button
							onClick={handleClickAdd}
							type={null}
							variant="primary"
							className="whitespace-nowrap flex gap-2 pl-4 py-2 justify-center items-center"
						>
							<div className="w-[18px]">
								<RiAddLine />
							</div>
							<span className="text-jsm">Subscription</span>
						</Button>
					</div>
				</div>
				<div className="card flex flex-col w-full">
					<div className="flex w-full justify-between py-4 px-6">
						<div className="flex gap-4 items-center">
							<div>
								<GenericSelect
									name="status"
									id="status"
									placeholder="Select Status"
									options={selectStatusOptions}
									value={selectedStatus}
									onChange={handleChangeStatus}
								/>
							</div>
							<div className="separator" />
							<div>
								<GenericDatePicker
									selected={currentSelectedDate}
									onChange={handleChangeDate}
								/>
							</div>
						</div>
						<div className="flex justify-center items-center">10 per page</div>
					</div>
					<div>
						<SubscriptionTable />
					</div>
				</div>
			</div>
		</BreadcrumbLayout>
	);
};

export default Subscription;
